import axios from 'utils/axios-interceptor';
import { API_URL } from '../../constants/config';
import ls from 'localstorage-slim';

export const getNotification = async (params) => {
  /*
    {
        perPage: 10,
        currentPage: 1,
        isRead: 2,
      }
      ### isRead:Number
      0 = not read notification
      1= read notification
      2 = all notification
*/
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.get(`${API_URL}/notification`, { headers, params });
  } catch (err) {
    throw new Error(err);
  }
};
export const deleteNotification = async (id) => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.delete(`${API_URL}/notification/remove/${id}`, { headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const deleteAllNotification = async () => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.delete(`${API_URL}/notification/remove-all`, { headers });
  } catch (err) {
    throw new Error(err);
  }
};
export const readNotification = async (id) => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.patch(`${API_URL}/notification/view/${id}`, {}, { headers });
  } catch (err) {
    throw new Error(err);
  }
};

export const readAllNotification = async () => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.patch(`${API_URL}/notification/read-all`, {}, { headers });
  } catch (err) {
    throw new Error(err);
  }
};
export const getNotificationCount = async () => {
  try {
    const headers = {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    };
    return await axios.get(`${API_URL}/notification/user/notification-count`, { headers });
  } catch (err) {
    throw new Error(err);
  }
};

// firebase notification setup

// sent device token api
export const createDeviceToken = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/notification/device-token`, payload, headers);
  } catch (err) {
    throw new Error(err);
  }
};
